import React from 'react';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import {
  RediscoveryPageContent,
  buildDefaultValues,
} from 'talent_matching/talent_rediscovery/rediscovery_page_content';
import { RediscoveryTabContextProvider } from 'talent_matching/contexts/rediscovery_tab_context';
import noop from 'lodash/noop';
import { useUserContext } from 'talent_matching/contexts/user_context';
import { RediscoveryProps } from 'talent_matching/types';

type Props = {
  rediscoveryProps: RediscoveryProps;
};

const TalentRediscovery = ({ rediscoveryProps }: Props) => {
  const { userDateFormat } = useUserContext();
  const defaultValues = buildDefaultValues(userDateFormat);

  return (
    <RediscoveryTabContextProvider rediscoveryProps={rediscoveryProps}>
      <Form defaultValues={defaultValues} onSubmit={noop} submitMode="preserve">
        <RediscoveryPageContent defaultValues={defaultValues} />
      </Form>
    </RediscoveryTabContextProvider>
  );
};

export default TalentRediscovery;
